import React from 'react';
import ServicePage from './ServicePage';
import { IconUserCheck, IconClipboard, IconLeaf } from '../../components/Icons';

const DATA = {
  icon: <IconUserCheck size={32} />, category: 'mineria',
  title: 'Asesorías en Temas Mineros',
  subtitle: 'Consultoría integral en normatividad, trámites y gestión técnica ante entidades mineras competentes.',
  norm: 'Decreto 1886/2015 – Ley 685/2001',
  desc: 'Ofrecemos acompañamiento técnico y normativo a mineros, empresas y asociaciones en todo tipo de trámites ante la ANM, así como capacitaciones en seguridad minera y cumplimiento de obligaciones legales establecidas en el Código de Minas.',
  details: [
    'Acompañamiento en trámites ante la ANM',
    'Gestión de títulos mineros y concesiones',
    'Asesoría en normatividad minera colombiana',
    'Elaboración de informes estadísticos de producción',
    'Capacitación técnica y normativa al personal',
    'Apoyo en visitas e inspecciones de autoridades',
  ],
  related: [
    { icon: <IconClipboard size={18} />, label: 'PTO', path: '/servicios/pto' },
    { icon: <IconLeaf size={18} />,      label: 'PMA', path: '/servicios/pma' },
  ],
};

export default function AsesoriasMine() { return <ServicePage data={DATA} />; }
